import { Box, Flex, xcss } from '@atlaskit/primitives';

import { RightHandSideProps } from '../../../common/types.js';
import {
	useGetSelectedCodingAgentAvatarsFromSearchParams,
	useIllustrationViewType,
} from '../../../controllers';
import { Injections, ProjectSvg } from '../../assets/project-svg.tsx';
import { JfindOnboardIllustrationRefresh } from '../../variant/jfind-onboard-illustration-refresh/jfind-onboard-illustration-refresh';

import { getListIssueTypeDynamicView } from './utils.tsx';
import { WorkTypeArrow } from './work-type-arrow.tsx';

export const RightHandSidePageWorkTypes = ({
	projectName,
	issueTypesIcons,
	isIllustrationRefresh,
}: RightHandSideProps) => {
	const illustrationViewType = useIllustrationViewType();

	const assignedAgents = useGetSelectedCodingAgentAvatarsFromSearchParams(4, 18);
	const DynamicWorkTypesSvg = getListIssueTypeDynamicView(issueTypesIcons ?? [], assignedAgents);
	const injections: Injections = {
		additionalObject: WorkTypeArrow,
		svgBody: DynamicWorkTypesSvg,
	};

	if (isIllustrationRefresh) {
		return (
			<Box xcss={illustrationRefreshContainerStyles}>
				<JfindOnboardIllustrationRefresh
					projectName={projectName}
					viewType={illustrationViewType}
					issueTypesIcons={issueTypesIcons}
				/>
			</Box>
		);
	}

	return (
		<Flex alignItems="center" justifyContent="center" xcss={containerStyles}>
			<ProjectSvg projectName={projectName} activeView="list" injections={injections} />
		</Flex>
	);
};
const containerStyles = xcss({
	height: '100%',
	backgroundColor: 'elevation.surface',
});

const illustrationRefreshContainerStyles = xcss({
	height: '100%',
	overflow: 'hidden',
});
